var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "view" }, [
      _c("h1", { staticClass: "come-info" }, [
        _vm._v("欢迎进入销售管理后台系统"),
      ]),
      _c("span", { staticClass: "el-icon-location el-icon--title" }, [
        _vm._v("首页"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }